<section [@triggerName]="prepareRoute(outlet)" class="router-animation-trigger">
  <app-particle-effects-overlay></app-particle-effects-overlay>
  <app-video-overlay [id]="videoTarget"></app-video-overlay>
  <router-outlet #outlet="outlet"></router-outlet>
</section>
